import RoomTypesTable from "./room-types-table";

const RoomTypes = () => {
  return (
    <div className="content-area">
      <RoomTypesTable />
    </div>
  );
};

export default RoomTypes;
